/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_4_AInputs */

const en_vc_faq_4_a = /** @type {(inputs: Vc_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Apple silicon and Intel), Windows (x64, ARM64 and 32-bit), Linux (x86_64 and ARM64 as AppImage, Flatpak, deb, rpm or tarball), FreeBSD 14 and the web.`)
};

const zh_vc_faq_4_a = /** @type {(inputs: Vc_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS（Apple 芯片和 Intel）、Windows（x64、ARM64 和 32 位）、Linux（x86_64 和 ARM64，提供 AppImage、Flatpak、deb、rpm 和压缩包）、FreeBSD 14，以及网页版。`)
};

/**
* | output |
* | --- |
* | "macOS (Apple silicon and Intel), Windows (x64, ARM64 and 32-bit), Linux (x86_64 and ARM64 as AppImage, Flatpak, deb, rpm or tarball), FreeBSD 14 and the web." |
*
* @param {Vc_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_4_a = /** @type {((inputs?: Vc_Faq_4_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_4_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_4_a(inputs)
	return zh_vc_faq_4_a(inputs)
});
export { vc_faq_4_a as "vc.faq.4.a" }